import React from 'react';

interface ArabAliLogoProps {
  className?: string;
  compact?: boolean;
  logoImage?: string;
  name?: string;
  subtitle?: string;
  location?: string;
  badgeLabel?: string;
}

const ArabAliLogo: React.FC<ArabAliLogoProps> = ({
  className = '',
  compact = false,
  logoImage,
  name = 'Arbali',
  subtitle = 'Hotel',
  location = 'Harar-Ethiopia',
  badgeLabel = 'Digital Menu',
}) => {
  const gateSize = compact ? 'h-11 w-11' : 'h-20 w-20';
  const icon = logoImage ? (
    <div
      className={`${gateSize} overflow-hidden rounded-[24px] border border-amber-300/25 bg-[#1a0c08] p-1`}
    >
      <img src={logoImage} alt={`${name} logo`} className="h-full w-full rounded-[20px] object-cover" />
    </div>
  ) : (
    <svg
      viewBox="0 0 88 88"
      aria-hidden="true"
      className={gateSize}
    >
      <defs>
        <linearGradient id="arabAliGate" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f6c75a" />
          <stop offset="100%" stopColor="#c17812" />
        </linearGradient>
      </defs>
      <rect x="6" y="6" width="76" height="76" rx="24" fill="#1a0c08" stroke="#f4ba4b" strokeWidth="2" />
      <path
        d="M14 20C25 10 63 10 74 20"
        fill="none"
        stroke="#f6c75a"
        strokeLinecap="round"
        strokeWidth="2.4"
      />
      <path
        d="M18 72C28 79 60 79 70 72"
        fill="none"
        stroke="#d99118"
        strokeLinecap="round"
        strokeWidth="2.2"
      />
      <path
        d="M20 58V28L30 18H58L68 28V58H54V39C54 33 49 28 44 28C39 28 34 33 34 39V58H20Z"
        fill="url(#arabAliGate)"
      />
      <path
        d="M39 58V40C39 36.5 41.7 34 44 34C46.3 34 49 36.5 49 40V58"
        fill="#1a0c08"
      />
      <rect x="20" y="58" width="16" height="14" rx="3" fill="#d99118" />
      <rect x="52" y="58" width="16" height="14" rx="3" fill="#d99118" />
      <text x="28" y="68" textAnchor="middle" fontSize="9" fontWeight="700" fill="#1a0c08">
        ARAB
      </text>
      <text x="60" y="68" textAnchor="middle" fontSize="10" fontWeight="700" fill="#1a0c08">
        ALI
      </text>
    </svg>
  );

  return (
    <div className={`inline-flex items-center gap-3 ${className}`.trim()}>
      {icon}
      {!compact && (
        <div className="leading-none">
          <div className="text-[10px] uppercase tracking-[0.55em] text-amber-100/60">{badgeLabel}</div>
          <div className="mt-2 text-4xl font-black italic tracking-tight text-white [text-shadow:0_3px_0_rgba(193,120,18,0.95),0_10px_24px_rgba(0,0,0,0.35)]">
            {name}
          </div>
          <div className="mt-1 text-2xl font-semibold italic text-amber-200 [text-shadow:0_3px_0_rgba(120,64,10,0.8)]">
            {subtitle}
          </div>
          <div className="mt-3 inline-flex rounded-full border border-amber-300/20 bg-white/5 px-3 py-1 text-[10px] uppercase tracking-[0.45em] text-amber-100/70">
            {location}
          </div>
        </div>
      )}
    </div>
  );
};

export default ArabAliLogo;
